(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-isaak-media-content-sc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function mhIsaakV2SplitMediaInit(scope) {
      scope.querySelectorAll('[data-mh-isaak-v2-split-video]').forEach(function (wrap) {
        if (wrap.dataset.mhIsaakV2SplitVideoInit === 'true') return;
        wrap.dataset.mhIsaakV2SplitVideoInit = 'true';

        const frame = wrap.querySelector('[data-video-frame]');
        if (!frame) return;

        const video = frame.querySelector('video');
        if (!video) return;

        const btn = wrap.querySelector('[data-mh-isaak-v2-split-video-btn]');
        const poster = wrap.querySelector('[data-mh-isaak-v2-split-video-poster]');
        const isAutoplay = wrap.dataset.mhIsaakV2SplitVideoAutoplay === 'true';

        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.playsInline = true;

        function setBtnVisible(isVisible) {
          if (!btn) return;
          if (isVisible) btn.classList.remove('mh_isaak_v2_state_btn_hidden');
          else btn.classList.add('mh_isaak_v2_state_btn_hidden');
        }

        function hidePoster() {
          if (poster) poster.classList.add('mh_isaak_v2_state_hidden');
        }

        function showPoster() {
          if (poster) poster.classList.remove('mh_isaak_v2_state_hidden');
        }

        if (isAutoplay) {
          setBtnVisible(false);
          hidePoster();
        } else {
          setBtnVisible(true);
          showPoster();
        }

        function playSafely() {
          setBtnVisible(false);
          hidePoster();

          if (video.readyState < 2) {
            try { video.load(); } catch (e) {}
            video.addEventListener('canplay', function onCanPlay() {
              video.removeEventListener('canplay', onCanPlay);
              playSafely();
            }, { once: true });
            return;
          }

          try {
            const p1 = video.play();
            if (p1 && typeof p1.catch === 'function') {
              p1.catch(function () {
                video.muted = true;
                video.setAttribute('muted', '');
                try {
                  const p2 = video.play();
                  if (p2 && typeof p2.catch === 'function') {
                    p2.catch(function () {
                      setBtnVisible(true);
                      if (video.currentTime <= 0.05) showPoster();
                    });
                  }
                } catch (e2) {
                  setBtnVisible(true);
                  if (video.currentTime <= 0.05) showPoster();
                }
              });
            }
          } catch (e) {
            video.muted = true;
            video.setAttribute('muted', '');
            try {
              const p3 = video.play();
              if (p3 && typeof p3.catch === 'function') {
                p3.catch(function () {
                  setBtnVisible(true);
                  if (video.currentTime <= 0.05) showPoster();
                });
              }
            } catch (e3) {
              setBtnVisible(true);
              if (video.currentTime <= 0.05) showPoster();
            }
          }
        }

        function togglePlay() {
  // If autoplay mode: never allow pausing via clicks
          if (isAutoplay) return;

          if (video.paused) playSafely();
          else video.pause();
        }

        if (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            togglePlay();
          });
        }

        if (poster) {
          poster.addEventListener('click', function (e) {
            e.preventDefault();
            togglePlay();
          });
        }

        video.addEventListener('click', function (e) {
          e.preventDefault();
          togglePlay();
        });

        video.addEventListener('play', function () {
          hidePoster();
          setBtnVisible(false);
          if (btn) btn.setAttribute('aria-label', 'Pause video');
        });

        video.addEventListener('pause', function () {
          setBtnVisible(true);
          if (btn) btn.setAttribute('aria-label', 'Play video');
          if (video.currentTime <= 0.05) showPoster();
        });

        video.addEventListener('ended', function () {
  if (isAutoplay) {
    hidePoster();
    setBtnVisible(false);
    playSafely();
    return;
  }

  showPoster();
  setBtnVisible(true);
  if (btn) btn.setAttribute('aria-label', 'Play video');
});

        if (isAutoplay) {
          video.muted = true;
          video.setAttribute('muted', '');
          playSafely();
        }
      });
    }

    mhIsaakV2SplitMediaInit(document);

    document.addEventListener('shopify:section:load', function (e) {
      mhIsaakV2SplitMediaInit(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
